










































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Cards from "@/components/Cards.vue";
import WhatsNext from "@/components/Communities/WhatsNext.vue";

@Component({
    components: {
        Cards,
        WhatsNext
    }
})
export default class MyCommunities extends Vue {
    public isMembership: boolean = true;
    public cards: any = {};
    public manageCards: any = [];
    public hideMobileFilters: boolean = false;
    public currentPage: number = 1;
    public perPage: number = 6;

    public toggleMobileFilters() {
        if (this.hideMobileFilters === true) {
            this.hideMobileFilters = false;
        } else {
            this.hideMobileFilters = true;
        }
    }

    get hasMore() {
        return this.cards && this.cards.list && this.cards.total > this.cards.list.length;
    }

    public async loadMore() {
        const nextPage: any = await this.$communityApi.getCommunities(
            ++this.currentPage,
            this.perPage,
            "joined"
        );
        this.cards.list.push(...nextPage.list);
    }

    public async mounted() {
        if (location.hash.includes("management")) {
            this.isMembership = false;
        }
        this.cards = await this.$communityApi.getCommunities(
            1,
            this.perPage,
            "joined"
        );
        this.manageCards = await this.$communityApi.getCommunities(
            1,
            50,
            "asLeader"
        );
    }
    @Watch("isMembership")
    onIsMembershipChange(val, oldVal) {
        if (val) {
            location.hash = location.hash.replace("#management", "");
        } else if (!location.hash.includes("#management")) {
            location.hash += "#management";
        }
    }
}
